<ng-container *ngIf="userHasLoaded">
  <app-header></app-header>
</ng-container>
